import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const { pageType } = window.inlineGlobalConfig;
const isProductGrid = pageType === 'product-list' || pageType === 'search-results';

const SizesList = ({
  sizes,
  onHoverSizeItem,
  onSelectSizeItem,
  selectedItem,
  allowOutOfStockSizes,
  scrollableList,
  disableNotifyMe,
  productType,
}) => {
  const intl = useIntl();
  return (
    <div
      className={`size-selector__list ${
        scrollableList ? 'size-selector__list--scrollable-list' : ''
      } size-selector__list--${productType.toLowerCase()}
    ${isProductGrid ? 'size-selector__list--grid' : ''}
    `}
    >
      {sizes.map(size => (
        <button
          type="button"
          aria-label={`${intl.formatMessage({
            id: 'products.details.screen.addToBag.size',
          })} ${size.size}`}
          key={size.sku}
          className={`size-selector__list-item ellipsis pdp-b 
            ${selectedItem && selectedItem.size === size.size ? 'size-selector__list-item--selected' : ''}
            ${
              (!allowOutOfStockSizes &&
                (!size.count || size.count <= 0) &&
                (!disableNotifyMe
                  ? `size-selector__list-item--disabled-${productType?.toLowerCase()}`
                  : `size-selector__list-item--disabled-notify-${productType?.toLowerCase()}`)) ||
              ''
            }
            size-selector__list-item--${productType?.toLowerCase()}
          `}
          onClick={() => onSelectSizeItem(size)}
          onMouseEnter={() => onHoverSizeItem(size)}
          onMouseLeave={() => onHoverSizeItem()}
        >
          {size.size}
        </button>
      ))}
    </div>
  );
};

SizesList.defaultProps = {
  allowOutOfStockSizes: false,
  selectedItem: null,
  scrollableList: false,
};

SizesList.propTypes = {
  sizes: PropTypes.arrayOf(
    PropTypes.shape({
      size: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      sku: PropTypes.string.isRequired,
    })
  ).isRequired,
  onHoverSizeItem: PropTypes.func.isRequired,
  onSelectSizeItem: PropTypes.func.isRequired,
  selectedItem: PropTypes.shape({
    size: PropTypes.string.isRequired,
  }),
  allowOutOfStockSizes: PropTypes.bool,
  scrollableList: PropTypes.bool,
  disableNotifyMe: PropTypes.bool.isRequired,
  productType: PropTypes.string.isRequired,
};

export default SizesList;
